import { useCallback, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { authSelector } from 'selectors/auth/authSelector';
import { userSelector } from 'selectors/user/userSelector';
import cmsDataSelector from 'selectors/page/autoReplenishment/cmsData/cmsDataSelector';
import AutoReplenishmentActions from 'actions/AutoReplenishmentActions';
import UserUtils from 'utils/User';

/**
 * Provides state for the AutoReplenishEmptyHub component.
 * Automatically dispatches the sign-in modal action when the user is not authenticated.
 *
 * @returns {{ cmsData: object }} `cmsData` — CMS content for the empty hub sections.
 */
const useAutoReplenishEmptyHub = () => {
    const dispatch = useDispatch();
    const cmsData = useSelector(cmsDataSelector);
    const user = useSelector(userSelector);
    const auth = useSelector(authSelector);

    const isLoggedIn = UserUtils.isSignedIn(auth);
    const shouldDisplaySignIn = user.isInitialized && !isLoggedIn;

    const showSignInModal = useCallback(() => {
        dispatch(AutoReplenishmentActions.showSignInModal());
    }, [dispatch]);

    useEffect(() => {
        if (shouldDisplaySignIn) {
            showSignInModal();
        }
    }, [shouldDisplaySignIn, showSignInModal]);

    return {
        cmsData
    };
};

export default useAutoReplenishEmptyHub;
